import { render, staticRenderFns } from "./Heatmap2.vue?vue&type=template&id=f1747120"
import script from "./Heatmap2.vue?vue&type=script&lang=js"
export * from "./Heatmap2.vue?vue&type=script&lang=js"
import style0 from "./Heatmap2.vue?vue&type=style&index=0&id=f1747120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports